import { render, staticRenderFns } from "./professionalRecommendation.vue?vue&type=template&id=50678720&scoped=true"
import script from "./professionalRecommendation.vue?vue&type=script&lang=js"
export * from "./professionalRecommendation.vue?vue&type=script&lang=js"
import style0 from "./professionalRecommendation.vue?vue&type=style&index=0&id=50678720&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50678720",
  null
  
)

export default component.exports